import { HeroSection } from './sections/HeroSection';
import { StorySection } from './sections/StorySection';
import { MeetTheHostsSection } from './sections/MeetTheHostsSection';
import { SubscribeSection } from './sections/SubscribeSection';
import { ALLOW_SUBSCRIPTIONS } from 'shared/constants/common';

export default function About() {
  return (
    <div className="pb-12 md:pb-24">
      <HeroSection />
      <StorySection />
      <MeetTheHostsSection />
      { ALLOW_SUBSCRIPTIONS ? <SubscribeSection /> : null }  
    </div>
  );
}
